import React from "react";
import { PartyPopper, ShieldCheck, Sparkles, Truck } from "lucide-react";
import { features } from "../../mock";

const iconMap = { PartyPopper, ShieldCheck, Sparkles, Truck };

const Features = () => {
  return (
    <section id="diferenciais" className="relative py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5">
        <span className="text-sm font-bold tracking-[0.2em] text-[#ec4899] uppercase">
          Por que escolher a gente
        </span>
        <h2 className="mt-4 font-display font-bold text-white text-3xl md:text-5xl leading-tight">
          Seu evento merece muita diversão!
        </h2>
        <p className="mt-6 text-gray-400 text-lg max-w-2xl leading-relaxed">
          Levamos diversão e alegria para aniversários, festas infantis, eventos
          corporativos, escolas, condomínios e comemorações especiais.
        </p>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((f) => {
            const Icon = iconMap[f.icon];
            return (
              <div
                key={f.title}
                className="group rounded-3xl border border-white/8 bg-[#0f0e17] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-white/15"
                style={{ boxShadow: "0 1px 0 rgba(255,255,255,0.03) inset" }}
              >
                <div
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-transform group-hover:scale-110"
                  style={{ backgroundColor: `${f.color}1a` }}
                >
                  <Icon size={30} style={{ color: f.color }} />
                </div>
                <h3 className="font-display font-bold text-white text-xl mb-3">
                  {f.title}
                </h3>
                <p className="text-gray-400 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
